import { Modal } from 'react-bootstrap'
import { cancelConfirmUpdate, confirmUpdatePromo } from 'actions/library/promo'
import styles from './UpdateConfirmationModal.css'
import { connect } from 'react-redux'

class UpdateConfirmationModal extends React.Component {
  render () {
    const {showUpdateConfirmModal, actionUpdateName} = this.props
    return (
      <Modal show={showUpdateConfirmModal} onHide={this._onHide} dialogClassName={`modal-dialog ${styles.dialog}`}>
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          <button
            onClick={this._onHide}
            type='button'
            className='close'
            data-dismiss='modal'
            aria-label='Close'>
            <span aria-hidden='true'>&times;</span>
          </button>
          Information
        </Modal.Header>
        <Modal.Body>
          <p>{`Are you sure want to ${actionUpdateName} this promo ?`}</p>
          <p>This changes will be applied to any outlet which use this promo</p>
        </Modal.Body>
        <Modal.Footer>
          <button onClick={this._onHide} className='btn btn-default'>
            Cancel
          </button>
          <button onClick={this._onConfirm} className='btn btn-primary'>
            Save
          </button>
        </Modal.Footer>
      </Modal>)
  }

  _onHide = () => {
    this.props.dispatch(cancelConfirmUpdate())
  }

  _onConfirm = () => {
    let {dispatch, nextUpdateAction} = this.props
    dispatch(confirmUpdatePromo(nextUpdateAction))
  }
}

function mapStateToProps (state) {
  const {showUpdateConfirmModal, actionUpdateName, outlets, nextUpdateAction} = state.library.promo
  return {
    showUpdateConfirmModal,
    actionUpdateName,
    outlets,
    nextUpdateAction
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateConfirmationModal)



// WEBPACK FOOTER //
// ./app/pages/Library/Promo/UpdateConfirmationModal/UpdateConfirmationModal.js